import React, { lazy } from 'react';
import costDistributionPolicyRoutes from './CostDistributionPolicy/CostDistributionPolicyRoutes';

const UnitCostAccountingSubmenu = lazy(() =>
  import('./UnitCostAccountingSubmenu').then(module => ({
    default: module.UnitCostAccountingSubmenu,
  })),
);

const ProjectMappingForm = lazy(() =>
  import('./ProjectMapping/ProjectMappingForm').then(module => ({
    default: module.ProjectMappingForm,
  })),
);

const unitCostAccountingRoutes = [
  {
    props: { exact: true, path: '/unit-cost-accounting' },
    component: <UnitCostAccountingSubmenu />,
  },
  {
    props: { exact: true, path: '/unit-cost-accounting/project-mapping' },
    component: <ProjectMappingForm />,
  },
  ...costDistributionPolicyRoutes,
];

export default unitCostAccountingRoutes;
